import { usePagination } from "react-instantsearch";
import {
  Button,
  ButtonSize,
  IconButton,
  IconButtonSize
} from "shared/components";
import { cx } from "shared/utils";
import {
  ArrowNarrowLeft,
  ArrowNarrowRight,
  ChevronLeftDouble,
  ChevronRightDouble
} from "untitledui-js-base";

// Docs for usePagination: https://www.algolia.com/doc/api-reference/widgets/pagination/react/#hook
export const CustomPagination = (props) => {
  const { pages, currentRefinement, isFirstPage, isLastPage, refine, nbPages } =
    usePagination(props);
  const previousPageIndex = currentRefinement - 1;
  const nextPageIndex = currentRefinement + 1;
  return (
    <div className="flex gap-2">
      <IconButton
        size={IconButtonSize.SM}
        onClick={() => refine(0)}
        disabled={isFirstPage}
        Icon={ChevronLeftDouble}
        className="shrink-0"
      />
      <Button
        size={ButtonSize.SM}
        onClick={() => refine(previousPageIndex)}
        disabled={isFirstPage}
        Icon={ArrowNarrowLeft}
      >
        Prev
      </Button>
      {pages.map((page) => {
        const label = page + 1;
        const isCurrent = currentRefinement === page;

        return (
          <Button
            key={page}
            size={ButtonSize.SM}
            onClick={() => refine(page)}
            disabled={false}
            aria-label={`Page ${label}`}
            iconPosition="right"
            className={cx(
              "max-w-[40px]",
              isCurrent && "border-2 border-primary-500"
            )}
          >
            {label}
          </Button>
        );
      })}
      <Button
        size={ButtonSize.SM}
        onClick={() => refine(nextPageIndex)}
        disabled={isLastPage}
        iconPosition="right"
        Icon={ArrowNarrowRight}
      >
        Next
      </Button>
      <IconButton
        size={IconButtonSize.SM}
        onClick={() => refine(nbPages - 1)}
        disabled={isLastPage}
        Icon={ChevronRightDouble}
        className="shrink-0"
      />
    </div>
  );
};
